module.exports = __webpack_public_path__ + "media/images/mailers/icon-a808e1c38091e7571de61dc75b99fe42.png";